import AnchorTarget from './anchor_target';
export default AnchorTarget;
